import { useCallback, useState } from 'react'
import { useSwipeable } from 'react-swipeable'

type UseSwipeHandlerProps = {
  direction: 'ttb' | 'rtl' | 'ltr'
  isAtEnd: boolean
  onNext?: () => void
}

type SwipeState = {
  progress: number
  isSwiping: boolean
}

export const useSwipeHandler = ({ direction, isAtEnd, onNext }: UseSwipeHandlerProps) => {
  const [swipeProgress, setSwipeProgress] = useState(0)
  const [isSwiping, setIsSwiping] = useState(false)

  const resetSwipeState = useCallback(() => {
    setSwipeProgress(0)
    setIsSwiping(false)
  }, [])

  const swipeHandler = useSwipeable({
    onSwipedUp: () => {
      if (direction === 'ttb' && isAtEnd && onNext && swipeProgress >= 100) {
        onNext()
      }
      resetSwipeState()
    },
    onSwiping: (eventData) => {
      // 最後のページでonNextが存在し、TTBモードの場合のみ進捗を表示

      if (!isAtEnd || !onNext || direction !== 'ttb') return
      setIsSwiping(true)
      // 下方向のスワイプ進捗を計算
      const threshold = window.innerHeight * 0.4
      if (eventData.deltaY > 0) {
        return
      }

      const progress = Math.min(100, (eventData.deltaY / threshold) * -100)
      setSwipeProgress(progress)
    },
    onTouchEndOrOnMouseUp: () => {
      resetSwipeState()
    },
    preventScrollOnSwipe: true,
    trackMouse: false,
    trackTouch: true,
    touchEventOptions: { passive: false },
  })

  const swipeState: SwipeState = {
    progress: swipeProgress,
    isSwiping,
  }

  return {
    swipeHandler,
    swipeState,
    resetSwipeState,
  }
}
